module.exports = __webpack_public_path__ + "bf2d0783515b7d75c35bde69e01b3135.woff";